import { CurrencyCode } from './storefront';
import { CountryCode } from './storefront';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  URL: { input: any; output: any; }
};

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AttributeInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Collection = {
  __typename?: 'Collection';
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  products?: Maybe<ProductsResponse>;
  ruleSet?: Maybe<CollectionRuleSet>;
  title: Scalars['String']['output'];
};


export type CollectionProductsArgs = {
  first: Scalars['Int']['input'];
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  nodes: Array<Collection>;
};

export type CollectionRule = {
  __typename?: 'CollectionRule';
  condition: Scalars['String']['output'];
};

export type CollectionRuleSet = {
  __typename?: 'CollectionRuleSet';
  rules: Array<CollectionRule>;
};

export enum CollectionSortKeys {
  Id = 'ID',
  Relevance = 'RELEVANCE',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

export type CollectionsResponse = {
  __typename?: 'CollectionsResponse';
  nodes: Array<Collection>;
  pageInfo: PageInfo;
};

export type ContextInput = {
  country?: InputMaybe<CountryCode>;
};

export { CountryCode };

export { CurrencyCode };

export type Customer = {
  __typename?: 'Customer';
  defaultAddress: MailingAddress;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type CustomersResponse = {
  __typename?: 'CustomersResponse';
  nodes: Array<Customer>;
  pageInfo: PageInfo;
};

export type DiscountAllocation = {
  __typename?: 'DiscountAllocation';
  allocatedAmountSet: MoneyBag;
};

export type DraftOrder = {
  __typename?: 'DraftOrder';
  billingAddress?: Maybe<MailingAddress>;
  createdAt: Scalars['DateTime']['output'];
  customAttributes: Array<Attribute>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItems: DraftOrderLineItemConnection;
  lineItemsSubtotalPrice: MoneyBag;
  name: Scalars['String']['output'];
  order?: Maybe<Order>;
  presentmentCurrencyCode: CurrencyCode;
  shippingAddress?: Maybe<MailingAddress>;
  shippingLine?: Maybe<ShippingLine>;
  status: DraftOrderStatus;
  subtotalPriceSet: MoneyBag;
  tags: Array<Scalars['String']['output']>;
  totalPriceSet: MoneyBag;
};


export type DraftOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DraftOrderAppliedDiscountInput = {
  amountWithCurrency?: InputMaybe<MoneyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
  valueType: DraftOrderAppliedDiscountType;
};

export enum DraftOrderAppliedDiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type DraftOrderCancelPayload = {
  __typename?: 'DraftOrderCancelPayload';
  draftOrder: DraftOrder;
  userErrors: Array<UserError>;
};

export type DraftOrderCompletePayload = {
  __typename?: 'DraftOrderCompletePayload';
  draftOrder: DraftOrder;
  userErrors: Array<UserError>;
};

export type DraftOrderCreatePayload = {
  __typename?: 'DraftOrderCreatePayload';
  draftOrder: DraftOrder;
  userErrors: Array<UserError>;
};

export type DraftOrderDeletePayload = {
  __typename?: 'DraftOrderDeletePayload';
  deletedId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type DraftOrderInput = {
  appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  billingAddress?: InputMaybe<MailingAddressInput>;
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<Array<DraftOrderLineItemInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  presentmentCurrencyCode?: InputMaybe<CurrencyCode>;
  shippingAddress?: InputMaybe<MailingAddressInput>;
  shippingLine?: InputMaybe<ShippingLineInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxExempt?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomerDefaultAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DraftOrderInvoiceSendPayload = {
  __typename?: 'DraftOrderInvoiceSendPayload';
  draftOrder: DraftOrder;
  userErrors: Array<UserError>;
};

export type DraftOrderLineItem = {
  __typename?: 'DraftOrderLineItem';
  custom: Scalars['Boolean']['output'];
  customAttributes: Array<Attribute>;
  id: Scalars['ID']['output'];
  originalTotalSet: MoneyBag;
  originalUnitPriceSet: MoneyBag;
  originalUnitPriceWithCurrency?: Maybe<Price>;
  priceOverride?: Maybe<Price>;
  quantity: Scalars['Int']['output'];
  requiresShipping: Scalars['Boolean']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  taxable: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  variant?: Maybe<ProductVariant>;
};

export type DraftOrderLineItemConnection = {
  __typename?: 'DraftOrderLineItemConnection';
  nodes: Array<DraftOrderLineItem>;
  pageInfo: PageInfo;
};

export type DraftOrderLineItemInput = {
  appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  customAttributes?: InputMaybe<Array<AttributeInput>>;
  originalUnitPriceWithCurrency?: InputMaybe<MoneyInput>;
  priceOverride?: InputMaybe<MoneyInput>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  requiresShipping?: InputMaybe<Scalars['Boolean']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

export enum DraftOrderSortKeys {
  CustomerName = 'CUSTOMER_NAME',
  Id = 'ID',
  Number = 'NUMBER',
  Relevance = 'RELEVANCE',
  Status = 'STATUS',
  TotalPrice = 'TOTAL_PRICE',
  UpdatedAt = 'UPDATED_AT'
}

export enum DraftOrderStatus {
  Completed = 'COMPLETED',
  InvoiceSent = 'INVOICE_SENT',
  Open = 'OPEN'
}

export type DraftOrderUpdatePayload = {
  __typename?: 'DraftOrderUpdatePayload';
  draftOrder: DraftOrder;
  userErrors: Array<UserError>;
};

export type DraftOrdersResponse = {
  __typename?: 'DraftOrdersResponse';
  nodes: Array<DraftOrder>;
  pageInfo: PageInfo;
};

export enum Frame {
  Black = 'black',
  Natural = 'natural',
  Unframed = 'unframed',
  White = 'white'
}

export type Image = {
  __typename?: 'Image';
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  src: Scalars['String']['output'];
  url: Scalars['URL']['output'];
  width: Scalars['Int']['output'];
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  nodes: Array<Image>;
};

export type LineItem = {
  __typename?: 'LineItem';
  customAttributes: Array<Attribute>;
  discountAllocations: Array<DiscountAllocation>;
  id: Scalars['String']['output'];
  originalTotalSet: MoneyBag;
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  variantTitle?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export type LineItems = {
  __typename?: 'LineItems';
  nodes: Array<LineItem>;
};

export type MailingAddress = {
  __typename?: 'MailingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCodeV2?: Maybe<CountryCode>;
  firstName?: Maybe<Scalars['String']['output']>;
  formatted: Array<Scalars['String']['output']>;
  formattedArea?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type MailingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryCode>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Media = {
  __typename?: 'Media';
  id: Scalars['ID']['output'];
  preview?: Maybe<MediaPreview>;
};

export type MediaPreview = {
  __typename?: 'MediaPreview';
  image?: Maybe<Image>;
};

export type Metafield = {
  __typename?: 'Metafield';
  key: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MetafieldAccessUpdateInput = {
  admin: MetafieldAdminAccess;
  storefront?: InputMaybe<MetafieldStorefrontAccess>;
};

export enum MetafieldAdminAccess {
  MerchantReadWrite = 'MERCHANT_READ_WRITE',
  PublicRead = 'PUBLIC_READ'
}

export type MetafieldDefinition = {
  __typename?: 'MetafieldDefinition';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
};

export type MetafieldDefinitionCreatePayload = {
  __typename?: 'MetafieldDefinitionCreatePayload';
  createdDefinition: MetafieldDefinition;
  metafieldDefinition: MetafieldDefinition;
  userErrors: Array<UserError>;
};

export type MetafieldDefinitionDeletePayload = {
  __typename?: 'MetafieldDefinitionDeletePayload';
  deletedDefinitionId: Scalars['ID']['output'];
  deletedMetafieldDefinitionId: Scalars['ID']['output'];
  userErrors: Array<UserError>;
};

export type MetafieldDefinitionInput = {
  access: MetafieldAccessUpdateInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  ownerType: Scalars['String']['input'];
  type: Scalars['String']['input'];
  valueType: Scalars['String']['input'];
};

export type MetafieldDefinitionUpdateInput = {
  access: MetafieldAccessUpdateInput;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  ownerType: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type MetafieldDefinitionUpdatePayload = {
  __typename?: 'MetafieldDefinitionUpdatePayload';
  metafieldDefinition: MetafieldDefinition;
  updatedDefinition: MetafieldDefinition;
  userErrors: Array<UserError>;
};

export enum MetafieldStorefrontAccess {
  PublicRead = 'PUBLIC_READ'
}

export type MoneyBag = {
  __typename?: 'MoneyBag';
  presentmentMoney: Price;
  shopMoney: Price;
};

export type MoneyInput = {
  amount: Scalars['Decimal']['input'];
  currencyCode: CurrencyCode;
};

export type Mutation = {
  __typename?: 'Mutation';
  draftOrderCancel: DraftOrderCancelPayload;
  draftOrderComplete: DraftOrderCompletePayload;
  draftOrderCreate: DraftOrderCreatePayload;
  draftOrderDelete: DraftOrderDeletePayload;
  draftOrderInvoiceSend: DraftOrderInvoiceSendPayload;
  draftOrderUpdate: DraftOrderUpdatePayload;
  metafieldDefinitionCreate: MetafieldDefinitionCreatePayload;
  metafieldDefinitionDelete: MetafieldDefinitionDeletePayload;
  metafieldDefinitionUpdate: MetafieldDefinitionUpdatePayload;
  productChangeStatus: ProductChangeStatusResult;
};


export type MutationDraftOrderCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftOrderCreateArgs = {
  input: DraftOrderInput;
};


export type MutationDraftOrderDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftOrderInvoiceSendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  input: DraftOrderInput;
};


export type MutationMetafieldDefinitionCreateArgs = {
  definition: MetafieldDefinitionInput;
};


export type MutationMetafieldDefinitionDeleteArgs = {
  deleteAllAssociatedMetafields?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMetafieldDefinitionUpdateArgs = {
  definition: MetafieldDefinitionUpdateInput;
};


export type MutationProductChangeStatusArgs = {
  productId: Scalars['ID']['input'];
  status: ProductStatus;
};

export enum OptionType {
  Frame = 'frame',
  Size = 'size'
}

export type Order = {
  __typename?: 'Order';
  createdAt: Scalars['String']['output'];
  customAttributes: Array<Attribute>;
  customer: Customer;
  discountCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lineItems: LineItems;
  metafield?: Maybe<Metafield>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};


export type OrderLineItemsArgs = {
  first: Scalars['Int']['input'];
};


export type OrderMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};

export enum OrderSortKeys {
  CreatedAt = 'CREATED_AT'
}

export type OrdersResponse = {
  __typename?: 'OrdersResponse';
  nodes: Array<Order>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['String']['output'];
  currencyCode: CurrencyCode;
};

export type PriceRange = {
  __typename?: 'PriceRange';
  maxVariantPrice: Price;
  minVariantPrice: Price;
};

export type Product = {
  __typename?: 'Product';
  collections: CollectionConnection;
  contextualPricing: ProductContextualPricing;
  defaultCursor: Scalars['String']['output'];
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  featuredMedia?: Maybe<Media>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: ImageConnection;
  metafield: Metafield;
  options: Array<ProductOption>;
  priceRangeV2: PriceRange;
  productType: Scalars['String']['output'];
  status: ProductStatus;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variants: ProductVariantConnection;
  vendor: Scalars['String']['output'];
};


export type ProductCollectionsArgs = {
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type ProductContextualPricingArgs = {
  context?: InputMaybe<ContextInput>;
};


export type ProductImagesArgs = {
  first: Scalars['Int']['input'];
};


export type ProductMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


export type ProductVariantsArgs = {
  first: Scalars['Int']['input'];
};

export type ProductChangeStatusResult = {
  __typename?: 'ProductChangeStatusResult';
  product: Product;
  userErrors: Array<UserError>;
};

export type ProductContextualPricing = {
  __typename?: 'ProductContextualPricing';
  maxVariantPrice?: Maybe<ProductVariantContextualPricing>;
  minVariantPrice?: Maybe<ProductVariantContextualPricing>;
  priceRange?: Maybe<ProductVariantContextualPriceRange>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionValues: Array<ProductOptionValue>;
  values: Array<Scalars['String']['output']>;
};

export type ProductOptionValue = {
  __typename?: 'ProductOptionValue';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ProductSortKeys {
  CreatedAt = 'CREATED_AT'
}

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  contextualPricing: ProductVariantContextualPricing;
  id: Scalars['String']['output'];
  price: Scalars['String']['output'];
  product: Product;
  selectedOptions: Array<SelectedOption>;
  sku: Scalars['String']['output'];
};


export type ProductVariantContextualPricingArgs = {
  context?: InputMaybe<ContextInput>;
};

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  nodes: Array<ProductVariant>;
};

export type ProductVariantContextualPriceRange = {
  __typename?: 'ProductVariantContextualPriceRange';
  maxVariantPrice?: Maybe<Price>;
  minVariantPrice?: Maybe<Price>;
};

export type ProductVariantContextualPricing = {
  __typename?: 'ProductVariantContextualPricing';
  price: Price;
};

export type ProductsCountResponse = {
  __typename?: 'ProductsCountResponse';
  count: Scalars['Int']['output'];
};

export type ProductsResponse = {
  __typename?: 'ProductsResponse';
  nodes: Array<Product>;
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  collections: CollectionsResponse;
  customers: CustomersResponse;
  draftOrder: DraftOrder;
  draftOrders: DraftOrdersResponse;
  orders: OrdersResponse;
  product: Product;
  productVariant: ProductVariant;
  products: ProductsResponse;
  productsCount: ProductsCountResponse;
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


export type QueryCustomersArgs = {
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDraftOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductVariantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


export type QueryProductsCountArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum RectangleSize {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3'
}

export type SelectedOption = {
  __typename?: 'SelectedOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ShippingLine = {
  __typename?: 'ShippingLine';
  discountedPriceSet: MoneyBag;
  title: Scalars['String']['output'];
};

export type ShippingLineInput = {
  priceWithCurrency?: InputMaybe<MoneyInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum Size {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  Size_12X12 = 'SIZE_12X12',
  Size_20X20 = 'SIZE_20X20',
  Size_28X28 = 'SIZE_28X28'
}

export enum SizeOrFrame {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  Black = 'BLACK',
  Natural = 'NATURAL',
  Size_12X12 = 'SIZE_12X12',
  Size_20X20 = 'SIZE_20X20',
  Size_28X28 = 'SIZE_28X28',
  Unframed = 'UNFRAMED',
  White = 'WHITE'
}

export enum SquareSize {
  Size_12X12 = 'SIZE_12X12',
  Size_20X20 = 'SIZE_20X20',
  Size_28X28 = 'SIZE_28X28'
}

export type UserError = {
  __typename?: 'UserError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AdminArtistProductVariantFragment = { __typename?: 'ProductVariant', id: string, price: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> };

export type AdminArtistProductFragment = { __typename?: 'Product', id: string, title: string, handle: string, productType: string, status: ProductStatus, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string, height: number, width: number }> }, artistName: { __typename?: 'Metafield', value: string }, artistPosition: { __typename?: 'Metafield', value: string }, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> } };

export type GetArtistProductsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  sortKey?: InputMaybe<ProductSortKeys>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArtistProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResponse', nodes: Array<{ __typename?: 'Product', id: string, title: string, handle: string, productType: string, status: ProductStatus, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string, height: number, width: number }> }, artistName: { __typename?: 'Metafield', value: string }, artistPosition: { __typename?: 'Metafield', value: string }, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type AdminProductFragment = { __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, vendor: string, tags: Array<string>, productType: string, artistName: { __typename?: 'Metafield', value: string }, artistPosition: { __typename?: 'Metafield', value: string }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', id: string, src: string, height: number, width: number }> }, contextualPricing: { __typename?: 'ProductContextualPricing', priceRange?: { __typename?: 'ProductVariantContextualPriceRange', minVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, maxVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null } | null }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, optionValues: Array<{ __typename?: 'ProductOptionValue', id: string, name: string }> }>, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, sku: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> }, orientation: { __typename?: 'Metafield', value: string, type: string }, medium: { __typename?: 'Metafield', value: string, type: string }, exclusiveToGoodMood: { __typename?: 'Metafield', value: string }, availableForCanvas: { __typename?: 'Metafield', value: string }, priceRangeV2: { __typename?: 'PriceRange', minVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, maxVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } };

export type GetAdminProductsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryCode>;
}>;


export type GetAdminProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResponse', nodes: Array<{ __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, vendor: string, tags: Array<string>, productType: string, artistName: { __typename?: 'Metafield', value: string }, artistPosition: { __typename?: 'Metafield', value: string }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', id: string, src: string, height: number, width: number }> }, contextualPricing: { __typename?: 'ProductContextualPricing', priceRange?: { __typename?: 'ProductVariantContextualPriceRange', minVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, maxVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null } | null }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, optionValues: Array<{ __typename?: 'ProductOptionValue', id: string, name: string }> }>, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, sku: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> }, orientation: { __typename?: 'Metafield', value: string, type: string }, medium: { __typename?: 'Metafield', value: string, type: string }, exclusiveToGoodMood: { __typename?: 'Metafield', value: string }, availableForCanvas: { __typename?: 'Metafield', value: string }, priceRangeV2: { __typename?: 'PriceRange', minVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, maxVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GetAdminProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  country?: InputMaybe<CountryCode>;
}>;


export type GetAdminProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, vendor: string, tags: Array<string>, productType: string, artistName: { __typename?: 'Metafield', value: string }, artistPosition: { __typename?: 'Metafield', value: string }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', id: string, src: string, height: number, width: number }> }, contextualPricing: { __typename?: 'ProductContextualPricing', priceRange?: { __typename?: 'ProductVariantContextualPriceRange', minVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, maxVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null } | null }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, optionValues: Array<{ __typename?: 'ProductOptionValue', id: string, name: string }> }>, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, sku: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> }, orientation: { __typename?: 'Metafield', value: string, type: string }, medium: { __typename?: 'Metafield', value: string, type: string }, exclusiveToGoodMood: { __typename?: 'Metafield', value: string }, availableForCanvas: { __typename?: 'Metafield', value: string }, priceRangeV2: { __typename?: 'PriceRange', minVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, maxVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } } };

export type GetAdminProductCountQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAdminProductCountQuery = { __typename?: 'Query', productsCount: { __typename?: 'ProductsCountResponse', count: number } };

export type ProductForTagsFragment = { __typename?: 'Product', id: string, tags: Array<string>, featuredMedia?: { __typename?: 'Media', preview?: { __typename?: 'MediaPreview', image?: { __typename?: 'Image', url: any } | null } | null } | null };

export type GetProductsForTagsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProductsForTagsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResponse', nodes: Array<{ __typename?: 'Product', id: string, tags: Array<string>, featuredMedia?: { __typename?: 'Media', preview?: { __typename?: 'MediaPreview', image?: { __typename?: 'Image', url: any } | null } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type GmcProductFragment = { __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, artistName: { __typename?: 'Metafield', value: string }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', id: string, src: string, height: number, width: number }> }, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'Collection', id: string, title: string }> }, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, contextualPricing: { __typename?: 'ProductVariantContextualPricing', price: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> } };

export type GetProductsForGmcQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryCode>;
}>;


export type GetProductsForGmcQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResponse', nodes: Array<{ __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, artistName: { __typename?: 'Metafield', value: string }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', id: string, src: string, height: number, width: number }> }, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'Collection', id: string, title: string }> }, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, contextualPricing: { __typename?: 'ProductVariantContextualPricing', price: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type AdminCustomerFragment = { __typename?: 'Customer', id: string, email: string, displayName: string, firstName: string, lastName: string, defaultAddress: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } };

export type GetCustomersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', customers: { __typename?: 'CustomersResponse', nodes: Array<{ __typename?: 'Customer', id: string, email: string, displayName: string, firstName: string, lastName: string, defaultAddress: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } }> } };

export type DraftOrderLineItemFragment = { __typename?: 'DraftOrderLineItem', id: string, uuid: string, title: string, quantity: number, custom: boolean, taxable: boolean, sku?: string | null, requiresShipping: boolean, priceOverride?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, variant?: { __typename?: 'ProductVariant', id: string, price: string, product: { __typename?: 'Product', id: string, title: string, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string }> }, artistName: { __typename?: 'Metafield', value: string } } } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, originalTotalSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, originalUnitPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, originalUnitPriceWithCurrency?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null };

export type DraftOrderFragment = { __typename?: 'DraftOrder', id: string, name: string, email?: string | null, tags: Array<string>, createdAt: any, status: DraftOrderStatus, presentmentCurrencyCode: CurrencyCode, billingAddress?: { __typename?: 'MailingAddress', city?: string | null, zip?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } | null, customer?: { __typename?: 'Customer', id: string, email: string, displayName: string, firstName: string, lastName: string, defaultAddress: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, shippingAddress?: { __typename?: 'MailingAddress', firstName?: string | null, lastName?: string | null, company?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } | null, shippingLine?: { __typename?: 'ShippingLine', title: string, discountedPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } } | null, subtotalPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, totalPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, lineItems: { __typename?: 'DraftOrderLineItemConnection', nodes: Array<{ __typename?: 'DraftOrderLineItem', id: string, uuid: string, title: string, quantity: number, custom: boolean, taxable: boolean, sku?: string | null, requiresShipping: boolean, priceOverride?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, variant?: { __typename?: 'ProductVariant', id: string, price: string, product: { __typename?: 'Product', id: string, title: string, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string }> }, artistName: { __typename?: 'Metafield', value: string } } } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, originalTotalSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, originalUnitPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, originalUnitPriceWithCurrency?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null }> } };

export type GetDraftOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDraftOrderQuery = { __typename?: 'Query', draftOrder: { __typename?: 'DraftOrder', id: string, name: string, email?: string | null, tags: Array<string>, createdAt: any, status: DraftOrderStatus, presentmentCurrencyCode: CurrencyCode, billingAddress?: { __typename?: 'MailingAddress', city?: string | null, zip?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } | null, customer?: { __typename?: 'Customer', id: string, email: string, displayName: string, firstName: string, lastName: string, defaultAddress: { __typename?: 'MailingAddress', address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, shippingAddress?: { __typename?: 'MailingAddress', firstName?: string | null, lastName?: string | null, company?: string | null, address1?: string | null, address2?: string | null, city?: string | null, zip?: string | null, country?: string | null, countryCodeV2?: CountryCode | null, formatted: Array<string>, formattedArea?: string | null } | null, shippingLine?: { __typename?: 'ShippingLine', title: string, discountedPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } } | null, subtotalPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, totalPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, lineItems: { __typename?: 'DraftOrderLineItemConnection', nodes: Array<{ __typename?: 'DraftOrderLineItem', id: string, uuid: string, title: string, quantity: number, custom: boolean, taxable: boolean, sku?: string | null, requiresShipping: boolean, priceOverride?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, variant?: { __typename?: 'ProductVariant', id: string, price: string, product: { __typename?: 'Product', id: string, title: string, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string }> }, artistName: { __typename?: 'Metafield', value: string } } } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, originalTotalSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, originalUnitPriceSet: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, originalUnitPriceWithCurrency?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null }> } } };

export type GetDraftOrdersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDraftOrdersQuery = { __typename?: 'Query', draftOrders: { __typename?: 'DraftOrdersResponse', nodes: Array<{ __typename?: 'DraftOrder', id: string, name: string, tags: Array<string>, status: DraftOrderStatus, createdAt: any, order?: { __typename?: 'Order', id: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, customer?: { __typename?: 'Customer', id: string, displayName: string } | null, lineItemsSubtotalPrice: { __typename?: 'MoneyBag', presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } }, lineItems: { __typename?: 'DraftOrderLineItemConnection', nodes: Array<{ __typename?: 'DraftOrderLineItem', id: string, title: string, quantity: number, originalUnitPriceWithCurrency?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null }> }, shippingAddress?: { __typename?: 'MailingAddress', country?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetProductVariantQueryVariables = Exact<{
  variantId: Scalars['ID']['input'];
  country?: InputMaybe<CountryCode>;
}>;


export type GetProductVariantQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', product: { __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, vendor: string, tags: Array<string>, productType: string, artistName: { __typename?: 'Metafield', value: string }, artistPosition: { __typename?: 'Metafield', value: string }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', id: string, src: string, height: number, width: number }> }, contextualPricing: { __typename?: 'ProductContextualPricing', priceRange?: { __typename?: 'ProductVariantContextualPriceRange', minVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null, maxVariantPrice?: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } | null } | null }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, optionValues: Array<{ __typename?: 'ProductOptionValue', id: string, name: string }> }>, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, sku: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> }, orientation: { __typename?: 'Metafield', value: string, type: string }, medium: { __typename?: 'Metafield', value: string, type: string }, exclusiveToGoodMood: { __typename?: 'Metafield', value: string }, availableForCanvas: { __typename?: 'Metafield', value: string }, priceRangeV2: { __typename?: 'PriceRange', minVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, maxVariantPrice: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } } } };

export type CreateDraftOrderMutationVariables = Exact<{
  input: DraftOrderInput;
}>;


export type CreateDraftOrderMutation = { __typename?: 'Mutation', draftOrderCreate: { __typename?: 'DraftOrderCreatePayload', draftOrder: { __typename?: 'DraftOrder', id: string }, userErrors: Array<{ __typename?: 'UserError', field?: string | null, message?: string | null }> } };

export type UpdateDraftOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: DraftOrderInput;
}>;


export type UpdateDraftOrderMutation = { __typename?: 'Mutation', draftOrderUpdate: { __typename?: 'DraftOrderUpdatePayload', draftOrder: { __typename?: 'DraftOrder', id: string }, userErrors: Array<{ __typename?: 'UserError', field?: string | null, message?: string | null }> } };

export type DeleteDraftOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDraftOrderMutation = { __typename?: 'Mutation', draftOrderDelete: { __typename?: 'DraftOrderDeletePayload', deletedId: string } };

export type SendDraftOrderInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendDraftOrderInvoiceMutation = { __typename?: 'Mutation', draftOrderInvoiceSend: { __typename?: 'DraftOrderInvoiceSendPayload', draftOrder: { __typename?: 'DraftOrder', id: string } } };

export type CompleteDraftOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompleteDraftOrderMutation = { __typename?: 'Mutation', draftOrderComplete: { __typename?: 'DraftOrderCompletePayload', draftOrder: { __typename?: 'DraftOrder', id: string } } };

export type AdminOrderLineItemFragment = { __typename?: 'LineItem', id: string, vendor: string, title: string, quantity: number, variantTitle?: string | null, product?: { __typename?: 'Product', id: string, title: string, handle: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, discountAllocations: Array<{ __typename?: 'DiscountAllocation', allocatedAmountSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }>, originalTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } };

export type AdminOrderFragment = { __typename?: 'Order', id: string, name: string, createdAt: string, discountCode: string, commission?: { __typename?: 'Metafield', value: string } | null, customer: { __typename?: 'Customer', firstName: string, lastName: string }, lineItems: { __typename?: 'LineItems', nodes: Array<{ __typename?: 'LineItem', id: string, vendor: string, title: string, quantity: number, variantTitle?: string | null, product?: { __typename?: 'Product', id: string, title: string, handle: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, discountAllocations: Array<{ __typename?: 'DiscountAllocation', allocatedAmountSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }>, originalTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }> } };

export type GetAdminOrdersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  sortKey?: InputMaybe<OrderSortKeys>;
  query?: InputMaybe<Scalars['String']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAdminOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersResponse', nodes: Array<{ __typename?: 'Order', id: string, name: string, createdAt: string, discountCode: string, commission?: { __typename?: 'Metafield', value: string } | null, customer: { __typename?: 'Customer', firstName: string, lastName: string }, lineItems: { __typename?: 'LineItems', nodes: Array<{ __typename?: 'LineItem', id: string, vendor: string, title: string, quantity: number, variantTitle?: string | null, product?: { __typename?: 'Product', id: string, title: string, handle: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, discountAllocations: Array<{ __typename?: 'DiscountAllocation', allocatedAmountSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }>, originalTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type ArtistOrderFragment = { __typename?: 'Order', id: string, createdAt: string, discountCode: string, commission?: { __typename?: 'Metafield', value: string } | null, lineItems: { __typename?: 'LineItems', nodes: Array<{ __typename?: 'LineItem', id: string, vendor: string, title: string, quantity: number, variantTitle?: string | null, product?: { __typename?: 'Product', id: string, title: string, handle: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, discountAllocations: Array<{ __typename?: 'DiscountAllocation', allocatedAmountSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }>, originalTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }> } };

export type GetArtistOrdersQueryVariables = Exact<{
  sortKey?: InputMaybe<OrderSortKeys>;
  query?: InputMaybe<Scalars['String']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArtistOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersResponse', nodes: Array<{ __typename?: 'Order', id: string, createdAt: string, discountCode: string, commission?: { __typename?: 'Metafield', value: string } | null, lineItems: { __typename?: 'LineItems', nodes: Array<{ __typename?: 'LineItem', id: string, vendor: string, title: string, quantity: number, variantTitle?: string | null, product?: { __typename?: 'Product', id: string, title: string, handle: string } | null, customAttributes: Array<{ __typename?: 'Attribute', key: string, value: string }>, discountAllocations: Array<{ __typename?: 'DiscountAllocation', allocatedAmountSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }>, originalTotalSet: { __typename?: 'MoneyBag', shopMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode }, presentmentMoney: { __typename?: 'Price', amount: string, currencyCode: CurrencyCode } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DashboardProductFragment = { __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, status: ProductStatus, productType: string, tags: Array<string>, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string, height: number, width: number }> }, medium: { __typename?: 'Metafield', value: string }, exclusiveToGoodMood: { __typename?: 'Metafield', value: string }, availableForCanvas: { __typename?: 'Metafield', value: string } };

export type GetDashboardProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDashboardProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, title: string, handle: string, descriptionHtml?: string | null, status: ProductStatus, productType: string, tags: Array<string>, variants: { __typename?: 'ProductVariantConnection', nodes: Array<{ __typename?: 'ProductVariant', id: string, price: string, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }> }> }, images: { __typename?: 'ImageConnection', nodes: Array<{ __typename?: 'Image', src: string, height: number, width: number }> }, medium: { __typename?: 'Metafield', value: string }, exclusiveToGoodMood: { __typename?: 'Metafield', value: string }, availableForCanvas: { __typename?: 'Metafield', value: string } } };

export type ChangeProductStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: ProductStatus;
}>;


export type ChangeProductStatusMutation = { __typename?: 'Mutation', productChangeStatus: { __typename?: 'ProductChangeStatusResult', product: { __typename?: 'Product', id: string } } };

export const AdminArtistProductVariantFragmentDoc = gql`
    fragment AdminArtistProductVariant on ProductVariant {
  id
  price
  selectedOptions {
    name
    value
  }
}
    `;
export const AdminArtistProductFragmentDoc = gql`
    fragment AdminArtistProduct on Product {
  id
  title
  handle
  productType
  status
  images(first: 1) {
    nodes {
      src
      height
      width
    }
  }
  artistName: metafield(namespace: "custom", key: "artist_name") {
    value
  }
  artistPosition: metafield(namespace: "custom", key: "artist_position") {
    value
  }
  variants(first: 1) {
    nodes {
      ...AdminArtistProductVariant
    }
  }
}
    ${AdminArtistProductVariantFragmentDoc}`;
export const AdminProductFragmentDoc = gql`
    fragment AdminProduct on Product {
  id
  title
  handle
  descriptionHtml
  artistName: metafield(namespace: "custom", key: "artist_name") {
    value
  }
  artistPosition: metafield(namespace: "custom", key: "artist_position") {
    value
  }
  images(first: 2) {
    nodes {
      id
      src
      height
      width
    }
  }
  vendor
  tags
  productType
  contextualPricing(context: {country: $country}) {
    priceRange {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
  }
  options {
    id
    name
    optionValues {
      id
      name
    }
  }
  variants(first: 20) {
    nodes {
      id
      price
      sku
      selectedOptions {
        name
        value
      }
    }
  }
  orientation: metafield(namespace: "custom", key: "orientation") {
    value
    type
  }
  medium: metafield(namespace: "custom", key: "medium") {
    value
    type
  }
  exclusiveToGoodMood: metafield(
    namespace: "custom"
    key: "exclusive_to_goodmood"
  ) {
    value
  }
  availableForCanvas: metafield(namespace: "custom", key: "available_for_canvas") {
    value
  }
  priceRangeV2 {
    minVariantPrice {
      amount
      currencyCode
    }
    maxVariantPrice {
      amount
      currencyCode
    }
  }
}
    `;
export const ProductForTagsFragmentDoc = gql`
    fragment ProductForTags on Product {
  id
  tags
  featuredMedia {
    preview {
      image {
        url
      }
    }
  }
}
    `;
export const GmcProductFragmentDoc = gql`
    fragment GmcProduct on Product {
  id
  title
  handle
  descriptionHtml
  artistName: metafield(namespace: "custom", key: "artist_name") {
    value
  }
  images(first: 2) {
    nodes {
      id
      src
      height
      width
    }
  }
  collections(
    first: 10
    query: "id:642877260154 OR id:642877358458 OR id:642877587834 OR id:642876998010 OR id:642877423994 OR id:642877391226 OR id:642877161850 OR id:642877325690 OR id:642877194618 OR id:642877129082 OR id:642877292922 OR id:642877227386 OR id:642877063546 OR id:651399102842 OR id:642877096314"
  ) {
    nodes {
      id
      title
    }
  }
  variants(first: 20) {
    nodes {
      id
      contextualPricing(context: {country: $country}) {
        price {
          amount
          currencyCode
        }
      }
      selectedOptions {
        name
        value
      }
    }
  }
}
    `;
export const AdminCustomerFragmentDoc = gql`
    fragment AdminCustomer on Customer {
  id
  email
  displayName
  firstName
  lastName
  defaultAddress {
    address1
    address2
    city
    zip
    countryCodeV2
    formatted
    formattedArea
  }
}
    `;
export const DraftOrderLineItemFragmentDoc = gql`
    fragment DraftOrderLineItem on DraftOrderLineItem {
  id
  uuid
  title
  quantity
  custom
  taxable
  sku
  priceOverride {
    amount
    currencyCode
  }
  requiresShipping
  variant {
    id
    price
    product {
      id
      title
      images(first: 1) {
        nodes {
          src
        }
      }
      artistName: metafield(namespace: "custom", key: "artist_name") {
        value
      }
    }
  }
  customAttributes {
    key
    value
  }
  originalTotalSet {
    presentmentMoney {
      amount
      currencyCode
    }
  }
  originalUnitPriceSet {
    presentmentMoney {
      amount
      currencyCode
    }
  }
  originalUnitPriceWithCurrency {
    amount
    currencyCode
  }
}
    `;
export const DraftOrderFragmentDoc = gql`
    fragment DraftOrder on DraftOrder {
  id
  name
  email
  tags
  createdAt
  status
  billingAddress {
    city
    zip
    countryCodeV2
    formatted
    formattedArea
  }
  presentmentCurrencyCode
  customer {
    ...AdminCustomer
  }
  customAttributes {
    key
    value
  }
  shippingAddress {
    firstName
    lastName
    company
    address1
    address2
    city
    zip
    country
    countryCodeV2
    formatted
    formattedArea
  }
  shippingLine {
    title
    discountedPriceSet {
      presentmentMoney {
        amount
        currencyCode
      }
    }
  }
  subtotalPriceSet {
    presentmentMoney {
      amount
      currencyCode
    }
  }
  totalPriceSet {
    presentmentMoney {
      amount
      currencyCode
    }
  }
  lineItems(first: 100) {
    nodes {
      ...DraftOrderLineItem
    }
  }
}
    ${AdminCustomerFragmentDoc}
${DraftOrderLineItemFragmentDoc}`;
export const AdminOrderLineItemFragmentDoc = gql`
    fragment AdminOrderLineItem on LineItem {
  id
  vendor
  title
  quantity
  product {
    id
    title
    handle
  }
  customAttributes {
    key
    value
  }
  variantTitle
  discountAllocations {
    allocatedAmountSet {
      shopMoney {
        amount
        currencyCode
      }
      presentmentMoney {
        amount
        currencyCode
      }
    }
  }
  originalTotalSet {
    shopMoney {
      amount
      currencyCode
    }
    presentmentMoney {
      amount
      currencyCode
    }
  }
}
    `;
export const AdminOrderFragmentDoc = gql`
    fragment AdminOrder on Order {
  id
  name
  createdAt
  discountCode
  commission: metafield(namespace: "custom", key: "commission") {
    value
  }
  customer {
    firstName
    lastName
  }
  lineItems(first: 250) {
    nodes {
      ...AdminOrderLineItem
    }
  }
}
    ${AdminOrderLineItemFragmentDoc}`;
export const ArtistOrderFragmentDoc = gql`
    fragment ArtistOrder on Order {
  id
  createdAt
  discountCode
  commission: metafield(namespace: "custom", key: "commission") {
    value
  }
  lineItems(first: 250) {
    nodes {
      id
      vendor
      title
      quantity
      product {
        id
        title
        handle
      }
      customAttributes {
        key
        value
      }
      variantTitle
      discountAllocations {
        allocatedAmountSet {
          shopMoney {
            amount
            currencyCode
          }
          presentmentMoney {
            amount
            currencyCode
          }
        }
      }
      originalTotalSet {
        shopMoney {
          amount
          currencyCode
        }
        presentmentMoney {
          amount
          currencyCode
        }
      }
    }
  }
}
    `;
export const DashboardProductFragmentDoc = gql`
    fragment DashboardProduct on Product {
  id
  title
  handle
  descriptionHtml
  status
  productType
  tags
  variants(first: 20) {
    nodes {
      id
      price
      selectedOptions {
        name
        value
      }
    }
  }
  images(first: 1) {
    nodes {
      src
      height
      width
    }
  }
  medium: metafield(namespace: "custom", key: "medium") {
    value
  }
  exclusiveToGoodMood: metafield(
    namespace: "custom"
    key: "exclusive_to_goodmood"
  ) {
    value
  }
  availableForCanvas: metafield(namespace: "custom", key: "available_for_canvas") {
    value
  }
}
    `;
export const GetArtistProductsDocument = gql`
    query getArtistProducts($limit: Int!, $sortKey: ProductSortKeys, $reverse: Boolean, $query: String, $afterCursor: String) {
  products(
    first: $limit
    sortKey: $sortKey
    reverse: $reverse
    after: $afterCursor
    query: $query
  ) {
    nodes {
      ...AdminArtistProduct
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AdminArtistProductFragmentDoc}`;

/**
 * __useGetArtistProductsQuery__
 *
 * To run a query within a React component, call `useGetArtistProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sortKey: // value for 'sortKey'
 *      reverse: // value for 'reverse'
 *      query: // value for 'query'
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useGetArtistProductsQuery(baseOptions: Apollo.QueryHookOptions<GetArtistProductsQuery, GetArtistProductsQueryVariables> & ({ variables: GetArtistProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistProductsQuery, GetArtistProductsQueryVariables>(GetArtistProductsDocument, options);
      }
export function useGetArtistProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistProductsQuery, GetArtistProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistProductsQuery, GetArtistProductsQueryVariables>(GetArtistProductsDocument, options);
        }
export function useGetArtistProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtistProductsQuery, GetArtistProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtistProductsQuery, GetArtistProductsQueryVariables>(GetArtistProductsDocument, options);
        }
export type GetArtistProductsQueryHookResult = ReturnType<typeof useGetArtistProductsQuery>;
export type GetArtistProductsLazyQueryHookResult = ReturnType<typeof useGetArtistProductsLazyQuery>;
export type GetArtistProductsSuspenseQueryHookResult = ReturnType<typeof useGetArtistProductsSuspenseQuery>;
export type GetArtistProductsQueryResult = Apollo.QueryResult<GetArtistProductsQuery, GetArtistProductsQueryVariables>;
export const GetAdminProductsDocument = gql`
    query getAdminProducts($limit: Int!, $query: String, $afterCursor: String, $sortKey: ProductSortKeys, $reverse: Boolean, $country: CountryCode) {
  products(
    first: $limit
    after: $afterCursor
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    nodes {
      ...AdminProduct
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${AdminProductFragmentDoc}`;

/**
 * __useGetAdminProductsQuery__
 *
 * To run a query within a React component, call `useGetAdminProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminProductsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      afterCursor: // value for 'afterCursor'
 *      sortKey: // value for 'sortKey'
 *      reverse: // value for 'reverse'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetAdminProductsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminProductsQuery, GetAdminProductsQueryVariables> & ({ variables: GetAdminProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminProductsQuery, GetAdminProductsQueryVariables>(GetAdminProductsDocument, options);
      }
export function useGetAdminProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminProductsQuery, GetAdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminProductsQuery, GetAdminProductsQueryVariables>(GetAdminProductsDocument, options);
        }
export function useGetAdminProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminProductsQuery, GetAdminProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminProductsQuery, GetAdminProductsQueryVariables>(GetAdminProductsDocument, options);
        }
export type GetAdminProductsQueryHookResult = ReturnType<typeof useGetAdminProductsQuery>;
export type GetAdminProductsLazyQueryHookResult = ReturnType<typeof useGetAdminProductsLazyQuery>;
export type GetAdminProductsSuspenseQueryHookResult = ReturnType<typeof useGetAdminProductsSuspenseQuery>;
export type GetAdminProductsQueryResult = Apollo.QueryResult<GetAdminProductsQuery, GetAdminProductsQueryVariables>;
export const GetAdminProductDocument = gql`
    query getAdminProduct($id: ID!, $country: CountryCode) {
  product(id: $id) {
    ...AdminProduct
  }
}
    ${AdminProductFragmentDoc}`;

/**
 * __useGetAdminProductQuery__
 *
 * To run a query within a React component, call `useGetAdminProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetAdminProductQuery(baseOptions: Apollo.QueryHookOptions<GetAdminProductQuery, GetAdminProductQueryVariables> & ({ variables: GetAdminProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminProductQuery, GetAdminProductQueryVariables>(GetAdminProductDocument, options);
      }
export function useGetAdminProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminProductQuery, GetAdminProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminProductQuery, GetAdminProductQueryVariables>(GetAdminProductDocument, options);
        }
export function useGetAdminProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminProductQuery, GetAdminProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminProductQuery, GetAdminProductQueryVariables>(GetAdminProductDocument, options);
        }
export type GetAdminProductQueryHookResult = ReturnType<typeof useGetAdminProductQuery>;
export type GetAdminProductLazyQueryHookResult = ReturnType<typeof useGetAdminProductLazyQuery>;
export type GetAdminProductSuspenseQueryHookResult = ReturnType<typeof useGetAdminProductSuspenseQuery>;
export type GetAdminProductQueryResult = Apollo.QueryResult<GetAdminProductQuery, GetAdminProductQueryVariables>;
export const GetAdminProductCountDocument = gql`
    query getAdminProductCount($query: String) {
  productsCount(query: $query) {
    count
  }
}
    `;

/**
 * __useGetAdminProductCountQuery__
 *
 * To run a query within a React component, call `useGetAdminProductCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminProductCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminProductCountQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAdminProductCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>(GetAdminProductCountDocument, options);
      }
export function useGetAdminProductCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>(GetAdminProductCountDocument, options);
        }
export function useGetAdminProductCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>(GetAdminProductCountDocument, options);
        }
export type GetAdminProductCountQueryHookResult = ReturnType<typeof useGetAdminProductCountQuery>;
export type GetAdminProductCountLazyQueryHookResult = ReturnType<typeof useGetAdminProductCountLazyQuery>;
export type GetAdminProductCountSuspenseQueryHookResult = ReturnType<typeof useGetAdminProductCountSuspenseQuery>;
export type GetAdminProductCountQueryResult = Apollo.QueryResult<GetAdminProductCountQuery, GetAdminProductCountQueryVariables>;
export const GetProductsForTagsDocument = gql`
    query getProductsForTags($limit: Int!, $query: String, $afterCursor: String, $sortKey: ProductSortKeys, $reverse: Boolean) {
  products(
    first: $limit
    after: $afterCursor
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    nodes {
      ...ProductForTags
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ProductForTagsFragmentDoc}`;

/**
 * __useGetProductsForTagsQuery__
 *
 * To run a query within a React component, call `useGetProductsForTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      afterCursor: // value for 'afterCursor'
 *      sortKey: // value for 'sortKey'
 *      reverse: // value for 'reverse'
 *   },
 * });
 */
export function useGetProductsForTagsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForTagsQuery, GetProductsForTagsQueryVariables> & ({ variables: GetProductsForTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForTagsQuery, GetProductsForTagsQueryVariables>(GetProductsForTagsDocument, options);
      }
export function useGetProductsForTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForTagsQuery, GetProductsForTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForTagsQuery, GetProductsForTagsQueryVariables>(GetProductsForTagsDocument, options);
        }
export function useGetProductsForTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsForTagsQuery, GetProductsForTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsForTagsQuery, GetProductsForTagsQueryVariables>(GetProductsForTagsDocument, options);
        }
export type GetProductsForTagsQueryHookResult = ReturnType<typeof useGetProductsForTagsQuery>;
export type GetProductsForTagsLazyQueryHookResult = ReturnType<typeof useGetProductsForTagsLazyQuery>;
export type GetProductsForTagsSuspenseQueryHookResult = ReturnType<typeof useGetProductsForTagsSuspenseQuery>;
export type GetProductsForTagsQueryResult = Apollo.QueryResult<GetProductsForTagsQuery, GetProductsForTagsQueryVariables>;
export const GetProductsForGmcDocument = gql`
    query getProductsForGMC($limit: Int!, $query: String, $afterCursor: String, $sortKey: ProductSortKeys, $reverse: Boolean, $country: CountryCode) {
  products(
    first: $limit
    after: $afterCursor
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    nodes {
      ...GmcProduct
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${GmcProductFragmentDoc}`;

/**
 * __useGetProductsForGmcQuery__
 *
 * To run a query within a React component, call `useGetProductsForGmcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForGmcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForGmcQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      afterCursor: // value for 'afterCursor'
 *      sortKey: // value for 'sortKey'
 *      reverse: // value for 'reverse'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetProductsForGmcQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForGmcQuery, GetProductsForGmcQueryVariables> & ({ variables: GetProductsForGmcQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForGmcQuery, GetProductsForGmcQueryVariables>(GetProductsForGmcDocument, options);
      }
export function useGetProductsForGmcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForGmcQuery, GetProductsForGmcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForGmcQuery, GetProductsForGmcQueryVariables>(GetProductsForGmcDocument, options);
        }
export function useGetProductsForGmcSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsForGmcQuery, GetProductsForGmcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsForGmcQuery, GetProductsForGmcQueryVariables>(GetProductsForGmcDocument, options);
        }
export type GetProductsForGmcQueryHookResult = ReturnType<typeof useGetProductsForGmcQuery>;
export type GetProductsForGmcLazyQueryHookResult = ReturnType<typeof useGetProductsForGmcLazyQuery>;
export type GetProductsForGmcSuspenseQueryHookResult = ReturnType<typeof useGetProductsForGmcSuspenseQuery>;
export type GetProductsForGmcQueryResult = Apollo.QueryResult<GetProductsForGmcQuery, GetProductsForGmcQueryVariables>;
export const GetCustomersDocument = gql`
    query getCustomers($limit: Int!, $query: String) {
  customers(first: $limit, query: $query) {
    nodes {
      ...AdminCustomer
    }
  }
}
    ${AdminCustomerFragmentDoc}`;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables> & ({ variables: GetCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export function useGetCustomersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetDraftOrderDocument = gql`
    query getDraftOrder($id: ID!) {
  draftOrder(id: $id) {
    ...DraftOrder
  }
}
    ${DraftOrderFragmentDoc}`;

/**
 * __useGetDraftOrderQuery__
 *
 * To run a query within a React component, call `useGetDraftOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDraftOrderQuery(baseOptions: Apollo.QueryHookOptions<GetDraftOrderQuery, GetDraftOrderQueryVariables> & ({ variables: GetDraftOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftOrderQuery, GetDraftOrderQueryVariables>(GetDraftOrderDocument, options);
      }
export function useGetDraftOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftOrderQuery, GetDraftOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftOrderQuery, GetDraftOrderQueryVariables>(GetDraftOrderDocument, options);
        }
export function useGetDraftOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDraftOrderQuery, GetDraftOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDraftOrderQuery, GetDraftOrderQueryVariables>(GetDraftOrderDocument, options);
        }
export type GetDraftOrderQueryHookResult = ReturnType<typeof useGetDraftOrderQuery>;
export type GetDraftOrderLazyQueryHookResult = ReturnType<typeof useGetDraftOrderLazyQuery>;
export type GetDraftOrderSuspenseQueryHookResult = ReturnType<typeof useGetDraftOrderSuspenseQuery>;
export type GetDraftOrderQueryResult = Apollo.QueryResult<GetDraftOrderQuery, GetDraftOrderQueryVariables>;
export const GetDraftOrdersDocument = gql`
    query getDraftOrders($limit: Int!, $cursor: String, $query: String, $sortKey: DraftOrderSortKeys, $reverse: Boolean) {
  draftOrders(
    first: $limit
    after: $cursor
    query: $query
    sortKey: $sortKey
    reverse: $reverse
  ) {
    nodes {
      id
      name
      tags
      status
      order {
        id
      }
      customAttributes {
        key
        value
      }
      customer {
        id
        displayName
      }
      createdAt
      lineItemsSubtotalPrice {
        presentmentMoney {
          amount
          currencyCode
        }
      }
      lineItems(first: 100) {
        nodes {
          id
          title
          quantity
          originalUnitPriceWithCurrency {
            amount
            currencyCode
          }
        }
      }
      shippingAddress {
        country
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetDraftOrdersQuery__
 *
 * To run a query within a React component, call `useGetDraftOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      query: // value for 'query'
 *      sortKey: // value for 'sortKey'
 *      reverse: // value for 'reverse'
 *   },
 * });
 */
export function useGetDraftOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetDraftOrdersQuery, GetDraftOrdersQueryVariables> & ({ variables: GetDraftOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftOrdersQuery, GetDraftOrdersQueryVariables>(GetDraftOrdersDocument, options);
      }
export function useGetDraftOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftOrdersQuery, GetDraftOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftOrdersQuery, GetDraftOrdersQueryVariables>(GetDraftOrdersDocument, options);
        }
export function useGetDraftOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDraftOrdersQuery, GetDraftOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDraftOrdersQuery, GetDraftOrdersQueryVariables>(GetDraftOrdersDocument, options);
        }
export type GetDraftOrdersQueryHookResult = ReturnType<typeof useGetDraftOrdersQuery>;
export type GetDraftOrdersLazyQueryHookResult = ReturnType<typeof useGetDraftOrdersLazyQuery>;
export type GetDraftOrdersSuspenseQueryHookResult = ReturnType<typeof useGetDraftOrdersSuspenseQuery>;
export type GetDraftOrdersQueryResult = Apollo.QueryResult<GetDraftOrdersQuery, GetDraftOrdersQueryVariables>;
export const GetProductVariantDocument = gql`
    query getProductVariant($variantId: ID!, $country: CountryCode) {
  productVariant(id: $variantId) {
    product {
      ...AdminProduct
    }
  }
}
    ${AdminProductFragmentDoc}`;

/**
 * __useGetProductVariantQuery__
 *
 * To run a query within a React component, call `useGetProductVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVariantQuery({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetProductVariantQuery(baseOptions: Apollo.QueryHookOptions<GetProductVariantQuery, GetProductVariantQueryVariables> & ({ variables: GetProductVariantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductVariantQuery, GetProductVariantQueryVariables>(GetProductVariantDocument, options);
      }
export function useGetProductVariantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductVariantQuery, GetProductVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductVariantQuery, GetProductVariantQueryVariables>(GetProductVariantDocument, options);
        }
export function useGetProductVariantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductVariantQuery, GetProductVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductVariantQuery, GetProductVariantQueryVariables>(GetProductVariantDocument, options);
        }
export type GetProductVariantQueryHookResult = ReturnType<typeof useGetProductVariantQuery>;
export type GetProductVariantLazyQueryHookResult = ReturnType<typeof useGetProductVariantLazyQuery>;
export type GetProductVariantSuspenseQueryHookResult = ReturnType<typeof useGetProductVariantSuspenseQuery>;
export type GetProductVariantQueryResult = Apollo.QueryResult<GetProductVariantQuery, GetProductVariantQueryVariables>;
export const CreateDraftOrderDocument = gql`
    mutation createDraftOrder($input: DraftOrderInput!) {
  draftOrderCreate(input: $input) {
    draftOrder {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type CreateDraftOrderMutationFn = Apollo.MutationFunction<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>;

/**
 * __useCreateDraftOrderMutation__
 *
 * To run a mutation, you first call `useCreateDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftOrderMutation, { data, loading, error }] = useCreateDraftOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>(CreateDraftOrderDocument, options);
      }
export type CreateDraftOrderMutationHookResult = ReturnType<typeof useCreateDraftOrderMutation>;
export type CreateDraftOrderMutationResult = Apollo.MutationResult<CreateDraftOrderMutation>;
export type CreateDraftOrderMutationOptions = Apollo.BaseMutationOptions<CreateDraftOrderMutation, CreateDraftOrderMutationVariables>;
export const UpdateDraftOrderDocument = gql`
    mutation updateDraftOrder($id: ID!, $input: DraftOrderInput!) {
  draftOrderUpdate(id: $id, input: $input) {
    draftOrder {
      id
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type UpdateDraftOrderMutationFn = Apollo.MutationFunction<UpdateDraftOrderMutation, UpdateDraftOrderMutationVariables>;

/**
 * __useUpdateDraftOrderMutation__
 *
 * To run a mutation, you first call `useUpdateDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftOrderMutation, { data, loading, error }] = useUpdateDraftOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDraftOrderMutation, UpdateDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDraftOrderMutation, UpdateDraftOrderMutationVariables>(UpdateDraftOrderDocument, options);
      }
export type UpdateDraftOrderMutationHookResult = ReturnType<typeof useUpdateDraftOrderMutation>;
export type UpdateDraftOrderMutationResult = Apollo.MutationResult<UpdateDraftOrderMutation>;
export type UpdateDraftOrderMutationOptions = Apollo.BaseMutationOptions<UpdateDraftOrderMutation, UpdateDraftOrderMutationVariables>;
export const DeleteDraftOrderDocument = gql`
    mutation deleteDraftOrder($id: ID!) {
  draftOrderDelete(id: $id) {
    deletedId
  }
}
    `;
export type DeleteDraftOrderMutationFn = Apollo.MutationFunction<DeleteDraftOrderMutation, DeleteDraftOrderMutationVariables>;

/**
 * __useDeleteDraftOrderMutation__
 *
 * To run a mutation, you first call `useDeleteDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftOrderMutation, { data, loading, error }] = useDeleteDraftOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDraftOrderMutation, DeleteDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDraftOrderMutation, DeleteDraftOrderMutationVariables>(DeleteDraftOrderDocument, options);
      }
export type DeleteDraftOrderMutationHookResult = ReturnType<typeof useDeleteDraftOrderMutation>;
export type DeleteDraftOrderMutationResult = Apollo.MutationResult<DeleteDraftOrderMutation>;
export type DeleteDraftOrderMutationOptions = Apollo.BaseMutationOptions<DeleteDraftOrderMutation, DeleteDraftOrderMutationVariables>;
export const SendDraftOrderInvoiceDocument = gql`
    mutation sendDraftOrderInvoice($id: ID!) {
  draftOrderInvoiceSend(id: $id) {
    draftOrder {
      id
    }
  }
}
    `;
export type SendDraftOrderInvoiceMutationFn = Apollo.MutationFunction<SendDraftOrderInvoiceMutation, SendDraftOrderInvoiceMutationVariables>;

/**
 * __useSendDraftOrderInvoiceMutation__
 *
 * To run a mutation, you first call `useSendDraftOrderInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDraftOrderInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDraftOrderInvoiceMutation, { data, loading, error }] = useSendDraftOrderInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendDraftOrderInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<SendDraftOrderInvoiceMutation, SendDraftOrderInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDraftOrderInvoiceMutation, SendDraftOrderInvoiceMutationVariables>(SendDraftOrderInvoiceDocument, options);
      }
export type SendDraftOrderInvoiceMutationHookResult = ReturnType<typeof useSendDraftOrderInvoiceMutation>;
export type SendDraftOrderInvoiceMutationResult = Apollo.MutationResult<SendDraftOrderInvoiceMutation>;
export type SendDraftOrderInvoiceMutationOptions = Apollo.BaseMutationOptions<SendDraftOrderInvoiceMutation, SendDraftOrderInvoiceMutationVariables>;
export const CompleteDraftOrderDocument = gql`
    mutation completeDraftOrder($id: ID!) {
  draftOrderComplete(id: $id) {
    draftOrder {
      id
    }
  }
}
    `;
export type CompleteDraftOrderMutationFn = Apollo.MutationFunction<CompleteDraftOrderMutation, CompleteDraftOrderMutationVariables>;

/**
 * __useCompleteDraftOrderMutation__
 *
 * To run a mutation, you first call `useCompleteDraftOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDraftOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDraftOrderMutation, { data, loading, error }] = useCompleteDraftOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteDraftOrderMutation(baseOptions?: Apollo.MutationHookOptions<CompleteDraftOrderMutation, CompleteDraftOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteDraftOrderMutation, CompleteDraftOrderMutationVariables>(CompleteDraftOrderDocument, options);
      }
export type CompleteDraftOrderMutationHookResult = ReturnType<typeof useCompleteDraftOrderMutation>;
export type CompleteDraftOrderMutationResult = Apollo.MutationResult<CompleteDraftOrderMutation>;
export type CompleteDraftOrderMutationOptions = Apollo.BaseMutationOptions<CompleteDraftOrderMutation, CompleteDraftOrderMutationVariables>;
export const GetAdminOrdersDocument = gql`
    query getAdminOrders($limit: Int!, $sortKey: OrderSortKeys, $query: String, $afterCursor: String, $reverse: Boolean) {
  orders(
    first: $limit
    sortKey: $sortKey
    reverse: $reverse
    query: $query
    after: $afterCursor
  ) {
    nodes {
      ...AdminOrder
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${AdminOrderFragmentDoc}`;

/**
 * __useGetAdminOrdersQuery__
 *
 * To run a query within a React component, call `useGetAdminOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminOrdersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      sortKey: // value for 'sortKey'
 *      query: // value for 'query'
 *      afterCursor: // value for 'afterCursor'
 *      reverse: // value for 'reverse'
 *   },
 * });
 */
export function useGetAdminOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetAdminOrdersQuery, GetAdminOrdersQueryVariables> & ({ variables: GetAdminOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminOrdersQuery, GetAdminOrdersQueryVariables>(GetAdminOrdersDocument, options);
      }
export function useGetAdminOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminOrdersQuery, GetAdminOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminOrdersQuery, GetAdminOrdersQueryVariables>(GetAdminOrdersDocument, options);
        }
export function useGetAdminOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminOrdersQuery, GetAdminOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminOrdersQuery, GetAdminOrdersQueryVariables>(GetAdminOrdersDocument, options);
        }
export type GetAdminOrdersQueryHookResult = ReturnType<typeof useGetAdminOrdersQuery>;
export type GetAdminOrdersLazyQueryHookResult = ReturnType<typeof useGetAdminOrdersLazyQuery>;
export type GetAdminOrdersSuspenseQueryHookResult = ReturnType<typeof useGetAdminOrdersSuspenseQuery>;
export type GetAdminOrdersQueryResult = Apollo.QueryResult<GetAdminOrdersQuery, GetAdminOrdersQueryVariables>;
export const GetArtistOrdersDocument = gql`
    query getArtistOrders($sortKey: OrderSortKeys, $query: String, $afterCursor: String) {
  orders(
    first: 250
    sortKey: $sortKey
    reverse: true
    query: $query
    after: $afterCursor
  ) {
    nodes {
      ...ArtistOrder
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${ArtistOrderFragmentDoc}`;

/**
 * __useGetArtistOrdersQuery__
 *
 * To run a query within a React component, call `useGetArtistOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtistOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtistOrdersQuery({
 *   variables: {
 *      sortKey: // value for 'sortKey'
 *      query: // value for 'query'
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useGetArtistOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>(GetArtistOrdersDocument, options);
      }
export function useGetArtistOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>(GetArtistOrdersDocument, options);
        }
export function useGetArtistOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>(GetArtistOrdersDocument, options);
        }
export type GetArtistOrdersQueryHookResult = ReturnType<typeof useGetArtistOrdersQuery>;
export type GetArtistOrdersLazyQueryHookResult = ReturnType<typeof useGetArtistOrdersLazyQuery>;
export type GetArtistOrdersSuspenseQueryHookResult = ReturnType<typeof useGetArtistOrdersSuspenseQuery>;
export type GetArtistOrdersQueryResult = Apollo.QueryResult<GetArtistOrdersQuery, GetArtistOrdersQueryVariables>;
export const GetDashboardProductDocument = gql`
    query GetDashboardProduct($id: ID!) {
  product(id: $id) {
    ...DashboardProduct
  }
}
    ${DashboardProductFragmentDoc}`;

/**
 * __useGetDashboardProductQuery__
 *
 * To run a query within a React component, call `useGetDashboardProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDashboardProductQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardProductQuery, GetDashboardProductQueryVariables> & ({ variables: GetDashboardProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardProductQuery, GetDashboardProductQueryVariables>(GetDashboardProductDocument, options);
      }
export function useGetDashboardProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardProductQuery, GetDashboardProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardProductQuery, GetDashboardProductQueryVariables>(GetDashboardProductDocument, options);
        }
export function useGetDashboardProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardProductQuery, GetDashboardProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardProductQuery, GetDashboardProductQueryVariables>(GetDashboardProductDocument, options);
        }
export type GetDashboardProductQueryHookResult = ReturnType<typeof useGetDashboardProductQuery>;
export type GetDashboardProductLazyQueryHookResult = ReturnType<typeof useGetDashboardProductLazyQuery>;
export type GetDashboardProductSuspenseQueryHookResult = ReturnType<typeof useGetDashboardProductSuspenseQuery>;
export type GetDashboardProductQueryResult = Apollo.QueryResult<GetDashboardProductQuery, GetDashboardProductQueryVariables>;
export const ChangeProductStatusDocument = gql`
    mutation ChangeProductStatus($id: ID!, $status: ProductStatus!) {
  productChangeStatus(productId: $id, status: $status) {
    product {
      id
    }
  }
}
    `;
export type ChangeProductStatusMutationFn = Apollo.MutationFunction<ChangeProductStatusMutation, ChangeProductStatusMutationVariables>;

/**
 * __useChangeProductStatusMutation__
 *
 * To run a mutation, you first call `useChangeProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeProductStatusMutation, { data, loading, error }] = useChangeProductStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeProductStatusMutation, ChangeProductStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeProductStatusMutation, ChangeProductStatusMutationVariables>(ChangeProductStatusDocument, options);
      }
export type ChangeProductStatusMutationHookResult = ReturnType<typeof useChangeProductStatusMutation>;
export type ChangeProductStatusMutationResult = Apollo.MutationResult<ChangeProductStatusMutation>;
export type ChangeProductStatusMutationOptions = Apollo.BaseMutationOptions<ChangeProductStatusMutation, ChangeProductStatusMutationVariables>;
export type AttributeKeySpecifier = ('key' | 'value' | AttributeKeySpecifier)[];
export type AttributeFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionKeySpecifier = ('handle' | 'id' | 'image' | 'products' | 'ruleSet' | 'title' | CollectionKeySpecifier)[];
export type CollectionFieldPolicy = {
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	image?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	ruleSet?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionConnectionKeySpecifier = ('nodes' | CollectionConnectionKeySpecifier)[];
export type CollectionConnectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionRuleKeySpecifier = ('condition' | CollectionRuleKeySpecifier)[];
export type CollectionRuleFieldPolicy = {
	condition?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionRuleSetKeySpecifier = ('rules' | CollectionRuleSetKeySpecifier)[];
export type CollectionRuleSetFieldPolicy = {
	rules?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionsResponseKeySpecifier = ('nodes' | 'pageInfo' | CollectionsResponseKeySpecifier)[];
export type CollectionsResponseFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerKeySpecifier = ('defaultAddress' | 'displayName' | 'email' | 'firstName' | 'id' | 'lastName' | CustomerKeySpecifier)[];
export type CustomerFieldPolicy = {
	defaultAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomersResponseKeySpecifier = ('nodes' | 'pageInfo' | CustomersResponseKeySpecifier)[];
export type CustomersResponseFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DiscountAllocationKeySpecifier = ('allocatedAmountSet' | DiscountAllocationKeySpecifier)[];
export type DiscountAllocationFieldPolicy = {
	allocatedAmountSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderKeySpecifier = ('billingAddress' | 'createdAt' | 'customAttributes' | 'customer' | 'email' | 'id' | 'lineItems' | 'lineItemsSubtotalPrice' | 'name' | 'order' | 'presentmentCurrencyCode' | 'shippingAddress' | 'shippingLine' | 'status' | 'subtotalPriceSet' | 'tags' | 'totalPriceSet' | DraftOrderKeySpecifier)[];
export type DraftOrderFieldPolicy = {
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItemsSubtotalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	presentmentCurrencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingLine?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalPriceSet?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPriceSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCancelPayloadKeySpecifier = ('draftOrder' | 'userErrors' | DraftOrderCancelPayloadKeySpecifier)[];
export type DraftOrderCancelPayloadFieldPolicy = {
	draftOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCompletePayloadKeySpecifier = ('draftOrder' | 'userErrors' | DraftOrderCompletePayloadKeySpecifier)[];
export type DraftOrderCompletePayloadFieldPolicy = {
	draftOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCreatePayloadKeySpecifier = ('draftOrder' | 'userErrors' | DraftOrderCreatePayloadKeySpecifier)[];
export type DraftOrderCreatePayloadFieldPolicy = {
	draftOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderDeletePayloadKeySpecifier = ('deletedId' | 'userErrors' | DraftOrderDeletePayloadKeySpecifier)[];
export type DraftOrderDeletePayloadFieldPolicy = {
	deletedId?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderInvoiceSendPayloadKeySpecifier = ('draftOrder' | 'userErrors' | DraftOrderInvoiceSendPayloadKeySpecifier)[];
export type DraftOrderInvoiceSendPayloadFieldPolicy = {
	draftOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderLineItemKeySpecifier = ('custom' | 'customAttributes' | 'id' | 'originalTotalSet' | 'originalUnitPriceSet' | 'originalUnitPriceWithCurrency' | 'priceOverride' | 'quantity' | 'requiresShipping' | 'sku' | 'taxable' | 'title' | 'uuid' | 'variant' | DraftOrderLineItemKeySpecifier)[];
export type DraftOrderLineItemFieldPolicy = {
	custom?: FieldPolicy<any> | FieldReadFunction<any>,
	customAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	originalTotalSet?: FieldPolicy<any> | FieldReadFunction<any>,
	originalUnitPriceSet?: FieldPolicy<any> | FieldReadFunction<any>,
	originalUnitPriceWithCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	priceOverride?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresShipping?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	taxable?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	uuid?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderLineItemConnectionKeySpecifier = ('nodes' | 'pageInfo' | DraftOrderLineItemConnectionKeySpecifier)[];
export type DraftOrderLineItemConnectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderUpdatePayloadKeySpecifier = ('draftOrder' | 'userErrors' | DraftOrderUpdatePayloadKeySpecifier)[];
export type DraftOrderUpdatePayloadFieldPolicy = {
	draftOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrdersResponseKeySpecifier = ('nodes' | 'pageInfo' | DraftOrdersResponseKeySpecifier)[];
export type DraftOrdersResponseFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('height' | 'id' | 'src' | 'url' | 'width' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	src?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageConnectionKeySpecifier = ('nodes' | ImageConnectionKeySpecifier)[];
export type ImageConnectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LineItemKeySpecifier = ('customAttributes' | 'discountAllocations' | 'id' | 'originalTotalSet' | 'product' | 'quantity' | 'title' | 'variantTitle' | 'vendor' | LineItemKeySpecifier)[];
export type LineItemFieldPolicy = {
	customAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	discountAllocations?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	originalTotalSet?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	variantTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LineItemsKeySpecifier = ('nodes' | LineItemsKeySpecifier)[];
export type LineItemsFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MailingAddressKeySpecifier = ('address1' | 'address2' | 'city' | 'company' | 'country' | 'countryCodeV2' | 'firstName' | 'formatted' | 'formattedArea' | 'lastName' | 'phone' | 'province' | 'zip' | MailingAddressKeySpecifier)[];
export type MailingAddressFieldPolicy = {
	address1?: FieldPolicy<any> | FieldReadFunction<any>,
	address2?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodeV2?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	formatted?: FieldPolicy<any> | FieldReadFunction<any>,
	formattedArea?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	province?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaKeySpecifier = ('id' | 'preview' | MediaKeySpecifier)[];
export type MediaFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	preview?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MediaPreviewKeySpecifier = ('image' | MediaPreviewKeySpecifier)[];
export type MediaPreviewFieldPolicy = {
	image?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetafieldKeySpecifier = ('key' | 'namespace' | 'type' | 'value' | MetafieldKeySpecifier)[];
export type MetafieldFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	namespace?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetafieldDefinitionKeySpecifier = ('description' | 'id' | 'key' | 'name' | 'namespace' | MetafieldDefinitionKeySpecifier)[];
export type MetafieldDefinitionFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	namespace?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetafieldDefinitionCreatePayloadKeySpecifier = ('createdDefinition' | 'metafieldDefinition' | 'userErrors' | MetafieldDefinitionCreatePayloadKeySpecifier)[];
export type MetafieldDefinitionCreatePayloadFieldPolicy = {
	createdDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	metafieldDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetafieldDefinitionDeletePayloadKeySpecifier = ('deletedDefinitionId' | 'deletedMetafieldDefinitionId' | 'userErrors' | MetafieldDefinitionDeletePayloadKeySpecifier)[];
export type MetafieldDefinitionDeletePayloadFieldPolicy = {
	deletedDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedMetafieldDefinitionId?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetafieldDefinitionUpdatePayloadKeySpecifier = ('metafieldDefinition' | 'updatedDefinition' | 'userErrors' | MetafieldDefinitionUpdatePayloadKeySpecifier)[];
export type MetafieldDefinitionUpdatePayloadFieldPolicy = {
	metafieldDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedDefinition?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoneyBagKeySpecifier = ('presentmentMoney' | 'shopMoney' | MoneyBagKeySpecifier)[];
export type MoneyBagFieldPolicy = {
	presentmentMoney?: FieldPolicy<any> | FieldReadFunction<any>,
	shopMoney?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('draftOrderCancel' | 'draftOrderComplete' | 'draftOrderCreate' | 'draftOrderDelete' | 'draftOrderInvoiceSend' | 'draftOrderUpdate' | 'metafieldDefinitionCreate' | 'metafieldDefinitionDelete' | 'metafieldDefinitionUpdate' | 'productChangeStatus' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	draftOrderCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderInvoiceSend?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	metafieldDefinitionCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	metafieldDefinitionDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	metafieldDefinitionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productChangeStatus?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('createdAt' | 'customAttributes' | 'customer' | 'discountCode' | 'id' | 'lineItems' | 'metafield' | 'name' | 'tags' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	customAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	discountCode?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lineItems?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrdersResponseKeySpecifier = ('nodes' | 'pageInfo' | OrdersResponseKeySpecifier)[];
export type OrdersResponseFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceKeySpecifier = ('amount' | 'currencyCode' | PriceKeySpecifier)[];
export type PriceFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PriceRangeKeySpecifier = ('maxVariantPrice' | 'minVariantPrice' | PriceRangeKeySpecifier)[];
export type PriceRangeFieldPolicy = {
	maxVariantPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minVariantPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('collections' | 'contextualPricing' | 'defaultCursor' | 'descriptionHtml' | 'featuredMedia' | 'handle' | 'id' | 'images' | 'metafield' | 'options' | 'priceRangeV2' | 'productType' | 'status' | 'tags' | 'title' | 'updatedAt' | 'variants' | 'vendor' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	contextualPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionHtml?: FieldPolicy<any> | FieldReadFunction<any>,
	featuredMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	handle?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRangeV2?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>,
	vendor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductChangeStatusResultKeySpecifier = ('product' | 'userErrors' | ProductChangeStatusResultKeySpecifier)[];
export type ProductChangeStatusResultFieldPolicy = {
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	userErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductContextualPricingKeySpecifier = ('maxVariantPrice' | 'minVariantPrice' | 'priceRange' | ProductContextualPricingKeySpecifier)[];
export type ProductContextualPricingFieldPolicy = {
	maxVariantPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minVariantPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRange?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductOptionKeySpecifier = ('id' | 'name' | 'optionValues' | 'values' | ProductOptionKeySpecifier)[];
export type ProductOptionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	optionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductOptionValueKeySpecifier = ('id' | 'name' | ProductOptionValueKeySpecifier)[];
export type ProductOptionValueFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantKeySpecifier = ('contextualPricing' | 'id' | 'price' | 'product' | 'selectedOptions' | 'sku' | ProductVariantKeySpecifier)[];
export type ProductVariantFieldPolicy = {
	contextualPricing?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	selectedOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantConnectionKeySpecifier = ('nodes' | ProductVariantConnectionKeySpecifier)[];
export type ProductVariantConnectionFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantContextualPriceRangeKeySpecifier = ('maxVariantPrice' | 'minVariantPrice' | ProductVariantContextualPriceRangeKeySpecifier)[];
export type ProductVariantContextualPriceRangeFieldPolicy = {
	maxVariantPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minVariantPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantContextualPricingKeySpecifier = ('price' | ProductVariantContextualPricingKeySpecifier)[];
export type ProductVariantContextualPricingFieldPolicy = {
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductsCountResponseKeySpecifier = ('count' | ProductsCountResponseKeySpecifier)[];
export type ProductsCountResponseFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductsResponseKeySpecifier = ('nodes' | 'pageInfo' | ProductsResponseKeySpecifier)[];
export type ProductsResponseFieldPolicy = {
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('collections' | 'customers' | 'draftOrder' | 'draftOrders' | 'orders' | 'product' | 'productVariant' | 'products' | 'productsCount' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	productsCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectedOptionKeySpecifier = ('name' | 'value' | SelectedOptionKeySpecifier)[];
export type SelectedOptionFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingLineKeySpecifier = ('discountedPriceSet' | 'title' | ShippingLineKeySpecifier)[];
export type ShippingLineFieldPolicy = {
	discountedPriceSet?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserErrorKeySpecifier = ('code' | 'field' | 'message' | UserErrorKeySpecifier)[];
export type UserErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Attribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeKeySpecifier | (() => undefined | AttributeKeySpecifier),
		fields?: AttributeFieldPolicy,
	},
	Collection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionKeySpecifier | (() => undefined | CollectionKeySpecifier),
		fields?: CollectionFieldPolicy,
	},
	CollectionConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionConnectionKeySpecifier | (() => undefined | CollectionConnectionKeySpecifier),
		fields?: CollectionConnectionFieldPolicy,
	},
	CollectionRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionRuleKeySpecifier | (() => undefined | CollectionRuleKeySpecifier),
		fields?: CollectionRuleFieldPolicy,
	},
	CollectionRuleSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionRuleSetKeySpecifier | (() => undefined | CollectionRuleSetKeySpecifier),
		fields?: CollectionRuleSetFieldPolicy,
	},
	CollectionsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionsResponseKeySpecifier | (() => undefined | CollectionsResponseKeySpecifier),
		fields?: CollectionsResponseFieldPolicy,
	},
	Customer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerKeySpecifier | (() => undefined | CustomerKeySpecifier),
		fields?: CustomerFieldPolicy,
	},
	CustomersResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomersResponseKeySpecifier | (() => undefined | CustomersResponseKeySpecifier),
		fields?: CustomersResponseFieldPolicy,
	},
	DiscountAllocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DiscountAllocationKeySpecifier | (() => undefined | DiscountAllocationKeySpecifier),
		fields?: DiscountAllocationFieldPolicy,
	},
	DraftOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderKeySpecifier | (() => undefined | DraftOrderKeySpecifier),
		fields?: DraftOrderFieldPolicy,
	},
	DraftOrderCancelPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCancelPayloadKeySpecifier | (() => undefined | DraftOrderCancelPayloadKeySpecifier),
		fields?: DraftOrderCancelPayloadFieldPolicy,
	},
	DraftOrderCompletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCompletePayloadKeySpecifier | (() => undefined | DraftOrderCompletePayloadKeySpecifier),
		fields?: DraftOrderCompletePayloadFieldPolicy,
	},
	DraftOrderCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCreatePayloadKeySpecifier | (() => undefined | DraftOrderCreatePayloadKeySpecifier),
		fields?: DraftOrderCreatePayloadFieldPolicy,
	},
	DraftOrderDeletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderDeletePayloadKeySpecifier | (() => undefined | DraftOrderDeletePayloadKeySpecifier),
		fields?: DraftOrderDeletePayloadFieldPolicy,
	},
	DraftOrderInvoiceSendPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderInvoiceSendPayloadKeySpecifier | (() => undefined | DraftOrderInvoiceSendPayloadKeySpecifier),
		fields?: DraftOrderInvoiceSendPayloadFieldPolicy,
	},
	DraftOrderLineItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderLineItemKeySpecifier | (() => undefined | DraftOrderLineItemKeySpecifier),
		fields?: DraftOrderLineItemFieldPolicy,
	},
	DraftOrderLineItemConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderLineItemConnectionKeySpecifier | (() => undefined | DraftOrderLineItemConnectionKeySpecifier),
		fields?: DraftOrderLineItemConnectionFieldPolicy,
	},
	DraftOrderUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderUpdatePayloadKeySpecifier | (() => undefined | DraftOrderUpdatePayloadKeySpecifier),
		fields?: DraftOrderUpdatePayloadFieldPolicy,
	},
	DraftOrdersResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrdersResponseKeySpecifier | (() => undefined | DraftOrdersResponseKeySpecifier),
		fields?: DraftOrdersResponseFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	ImageConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageConnectionKeySpecifier | (() => undefined | ImageConnectionKeySpecifier),
		fields?: ImageConnectionFieldPolicy,
	},
	LineItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LineItemKeySpecifier | (() => undefined | LineItemKeySpecifier),
		fields?: LineItemFieldPolicy,
	},
	LineItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LineItemsKeySpecifier | (() => undefined | LineItemsKeySpecifier),
		fields?: LineItemsFieldPolicy,
	},
	MailingAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MailingAddressKeySpecifier | (() => undefined | MailingAddressKeySpecifier),
		fields?: MailingAddressFieldPolicy,
	},
	Media?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaKeySpecifier | (() => undefined | MediaKeySpecifier),
		fields?: MediaFieldPolicy,
	},
	MediaPreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MediaPreviewKeySpecifier | (() => undefined | MediaPreviewKeySpecifier),
		fields?: MediaPreviewFieldPolicy,
	},
	Metafield?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetafieldKeySpecifier | (() => undefined | MetafieldKeySpecifier),
		fields?: MetafieldFieldPolicy,
	},
	MetafieldDefinition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetafieldDefinitionKeySpecifier | (() => undefined | MetafieldDefinitionKeySpecifier),
		fields?: MetafieldDefinitionFieldPolicy,
	},
	MetafieldDefinitionCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetafieldDefinitionCreatePayloadKeySpecifier | (() => undefined | MetafieldDefinitionCreatePayloadKeySpecifier),
		fields?: MetafieldDefinitionCreatePayloadFieldPolicy,
	},
	MetafieldDefinitionDeletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetafieldDefinitionDeletePayloadKeySpecifier | (() => undefined | MetafieldDefinitionDeletePayloadKeySpecifier),
		fields?: MetafieldDefinitionDeletePayloadFieldPolicy,
	},
	MetafieldDefinitionUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetafieldDefinitionUpdatePayloadKeySpecifier | (() => undefined | MetafieldDefinitionUpdatePayloadKeySpecifier),
		fields?: MetafieldDefinitionUpdatePayloadFieldPolicy,
	},
	MoneyBag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoneyBagKeySpecifier | (() => undefined | MoneyBagKeySpecifier),
		fields?: MoneyBagFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	OrdersResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrdersResponseKeySpecifier | (() => undefined | OrdersResponseKeySpecifier),
		fields?: OrdersResponseFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	Price?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceKeySpecifier | (() => undefined | PriceKeySpecifier),
		fields?: PriceFieldPolicy,
	},
	PriceRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PriceRangeKeySpecifier | (() => undefined | PriceRangeKeySpecifier),
		fields?: PriceRangeFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductChangeStatusResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductChangeStatusResultKeySpecifier | (() => undefined | ProductChangeStatusResultKeySpecifier),
		fields?: ProductChangeStatusResultFieldPolicy,
	},
	ProductContextualPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductContextualPricingKeySpecifier | (() => undefined | ProductContextualPricingKeySpecifier),
		fields?: ProductContextualPricingFieldPolicy,
	},
	ProductOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductOptionKeySpecifier | (() => undefined | ProductOptionKeySpecifier),
		fields?: ProductOptionFieldPolicy,
	},
	ProductOptionValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductOptionValueKeySpecifier | (() => undefined | ProductOptionValueKeySpecifier),
		fields?: ProductOptionValueFieldPolicy,
	},
	ProductVariant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantKeySpecifier | (() => undefined | ProductVariantKeySpecifier),
		fields?: ProductVariantFieldPolicy,
	},
	ProductVariantConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantConnectionKeySpecifier | (() => undefined | ProductVariantConnectionKeySpecifier),
		fields?: ProductVariantConnectionFieldPolicy,
	},
	ProductVariantContextualPriceRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantContextualPriceRangeKeySpecifier | (() => undefined | ProductVariantContextualPriceRangeKeySpecifier),
		fields?: ProductVariantContextualPriceRangeFieldPolicy,
	},
	ProductVariantContextualPricing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantContextualPricingKeySpecifier | (() => undefined | ProductVariantContextualPricingKeySpecifier),
		fields?: ProductVariantContextualPricingFieldPolicy,
	},
	ProductsCountResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductsCountResponseKeySpecifier | (() => undefined | ProductsCountResponseKeySpecifier),
		fields?: ProductsCountResponseFieldPolicy,
	},
	ProductsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductsResponseKeySpecifier | (() => undefined | ProductsResponseKeySpecifier),
		fields?: ProductsResponseFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	SelectedOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectedOptionKeySpecifier | (() => undefined | SelectedOptionKeySpecifier),
		fields?: SelectedOptionFieldPolicy,
	},
	ShippingLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingLineKeySpecifier | (() => undefined | ShippingLineKeySpecifier),
		fields?: ShippingLineFieldPolicy,
	},
	UserError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserErrorKeySpecifier | (() => undefined | UserErrorKeySpecifier),
		fields?: UserErrorFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    